import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from '@mui/material/styles';
import HorizontalDivider from "../horizontaldivider/horizontaldivider";
import "./popup.scss";

interface IPopup {
    children: React.ReactNode;
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    title: string
    close: () => void
}

export default function Popup({children, open, close, setOpen, title}: IPopup) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <div className="Popup">
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={close}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    <div className="d-flex justify-content-between align-items-center">
                        <div style={{cursor: 'pointer'}} onClick={() => {
                            setOpen(false);
                        }}>
                            <img src={require("../../assets/images/icons/Close.svg").default} alt=""
                                 className="img-fluid"/>
                        </div>
                        <span>{title}</span>
                        <div></div>
                    </div>
                    <HorizontalDivider/>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {children}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    );
}